import React from 'react';
import classnames from 'classnames';
import LucideIcon from 'src/componentes/lucide-icon';
import css from 'src/utils/css';

const classes = css`
  .container {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 10px 16px;
    border-radius: 8px;
    border: 1px solid #e4e4e7;
    background: #fff;
    box-shadow: 0 1px 2px 0 #f4f4f5;
  }

  .icone {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    color: #a1a1aa;
    pointer-events: none;
  }

  .input {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    padding: 0;
    margin: 0;
    color: #09090b;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0;
    box-shadow: none;
  }

  .input::placeholder {
    color: #a1a1aa;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0;
    opacity: 1;
  }

  .input:focus {
    outline: none;
    box-shadow: none;
  }
`;

function InputBusca({ className, style, placeholder, value, onChange, ...rest }) {
  return (
    <div className={classnames(classes.container, className)} style={style}>
      <span className={classes.icone}>
        <LucideIcon icon="magnify" size={16} color="#A1A1AA" />
      </span>
      <input
        type="text"
        className={classes.input}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...rest}
      />
    </div>
  );
}

export default InputBusca;
